import {
  GET_ADMIN_CHANGE_HISTORY,
  GET_ADMIN_CHANGE_HISTORY_ERROR,
  GET_ADMIN_CHANGE_HISTORY_SUCCESS,
  GET_ADMIN_CHANGE_HISTORY_EXPORT,
  GET_ADMIN_CHANGE_HISTORY_EXPORT_SUCCESS,
  GET_ADMIN_CHANGE_HISTORY_EXPORT_ERROR,
} from "./actionTypes"

export const getAdminChangeHistory = (query_params, paginated) => {
  return {
    type: GET_ADMIN_CHANGE_HISTORY,
    payload: query_params,
    paginated: paginated
  }
}

export const getAdminChangeHistorySuccess = (admin_change_history, meta = {}) => {
  return {
    type: GET_ADMIN_CHANGE_HISTORY_SUCCESS,
    payload: admin_change_history,
    meta,
  }
}

export const getAdminChangeHistoryError = error => {
  return {
    type: GET_ADMIN_CHANGE_HISTORY_ERROR,
    payload: error
  }
}

export const getAdminChangeHistoryExport = (query_params) => {
  return {
    type: GET_ADMIN_CHANGE_HISTORY_EXPORT,
    payload: query_params
  }
}

export const getAdminChangeHistoryExportSuccess = () => {
  return {
    type: GET_ADMIN_CHANGE_HISTORY_EXPORT_SUCCESS
  }
}

export const getAdminChangeHistoryExportError = () => {
  return {
    type: GET_ADMIN_CHANGE_HISTORY_EXPORT_ERROR
  }
}
